export default {"src":"/_next/static/media/oncology-icon.8f917e67.svg","height":195,"width":200,"blurWidth":0,"blurHeight":0};